export default __webpack_public_path__ + "static/media/warning.b07632ba.png";